import { render, staticRenderFns } from "./bindFirm.vue?vue&type=template&id=1b30209e&scoped=true&"
import script from "./bindFirm.vue?vue&type=script&lang=js&"
export * from "./bindFirm.vue?vue&type=script&lang=js&"
import style0 from "./bindFirm.vue?vue&type=style&index=0&id=1b30209e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b30209e",
  null
  
)

export default component.exports